import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch('/api/auth/user', { credentials: 'include' });
        if (response.ok) {
          const data = await response.json();
          if (data.authenticated) {
            setUser({
              email: data.email,
              name: data.name,
              role: data.role,
              is_superuser: data.is_superuser
            });
            setIsAuthenticated(true);
          }
        }
      } catch (e) {
        // Session check failed; remain logged out
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  const isSuperuser = user?.is_superuser === true;

  const login = () => {
    // Redirect to the Cloudflare Pages Function that initiates Microsoft Entra SSO.
    window.location.href = '/api/auth/login';
  };

  const logout = () => {
    // Redirect to the Cloudflare Pages Function that clears the session cookie.
    window.location.href = '/api/auth/logout';
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, isSuperuser, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);